module.exports = __webpack_public_path__ + "static/media/Team 18 Stranger Thinks -logos_transparent - Caio Portella.000a2fc5.png";